// extracted by mini-css-extract-plugin
export var stepActive = "_2x-3";
export var stepCompleted = "_2x-4";
export var stepConnectorLine = "_2x-b";
export var stepIndicatorCircle = "_2x-6";
export var stepIndicatorCircleCompleted = "_2x-7";
export var stepIndicatorCircleDefault = "_2x-8";
export var stepIndicatorTextCompleted = "_2x-9";
export var stepIndicatorTextDefault = "_2x-a";
export var stepPending = "_2x-5";
export var wizardContainer = "_2x-1";
export var wizardContent = "_2x-2";
export var wizardModal = "_2x-0";